<template>
  <v-container>
    <v-layout row wrap align-center>
      <v-flex>
        <div class="headline text-center">
          View Uploaded Attachments
        </div>
        <ListAttachments />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ListAttachments from "@/components/ListAttachments.vue";

export default {
  components: {
    ListAttachments
  }
};
</script>
